import React from "react";
import MenuComponent from "../../components/LabelButton";
import {
  Badge,
  Box,
  Button,
  Paper,
  ScrollArea,
  Space,
  Tabs,
  Title,
  createStyles,
} from "@mantine/core";
import { useMedplum } from "@medplum/react";
import { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { InfoBar } from "../../components/InfoBar";
import { MedplumClient, resolveId } from "@medplum/core";
import { ConnectedPlatforms } from "../../components/ConnectedPlatforms";
import { useSelector } from "react-redux";
import { AppState } from "../../store/types/appState";


const useStyles = createStyles(() => ({
  root: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  platforms: {
    display: "flex",
    justifyContent: "center",
  },
  platformImg: {
    width: "2rem",
    marginLeft: "5px",
  },
}));

export function IntegrationPage(): JSX.Element {
  const medplum = useMedplum();
  const { classes } = useStyles();
  const userProfile = useSelector((state: AppState) => state) as any;

  function getProjectId(medplum: MedplumClient): string {
    return resolveId(medplum.getActiveLogin()?.project) as string;
  }
  const projectId = getProjectId(medplum);
  const result = useMemo(
    () => medplum.get("admin/projects/" + projectId).read(),
    [medplum, projectId]
  );
  /**
   * Handles a tab change event.
   * @param newTabName - The new tab name.
   */
 
  return (
    <>
      <Space h="md" />
      <Paper
        sx={{
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "16px",
          }}
        >
          <Box sx={{ justifyContent: "flex-start" }}>
            <InfoBar>
              <InfoBar.Entry>
                <InfoBar.Value>{"Integrations"}</InfoBar.Value>
              </InfoBar.Entry>

             
            </InfoBar>
          </Box>
          <Box
            sx={{
              justifyContent: "flex-end",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MenuComponent />
          </Box>
        </Box>
        <ScrollArea
          sx={{
            marginLeft: "10px",
          }}
        >
         
        </ScrollArea>
      </Paper>
      <Space h="md" />
      <Paper
        sx={{
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        className={classes.root}
      >
        <Outlet />
      </Paper>
    </>
  );
}
